import React from 'react'
import { Controller, Control, UseControllerProps } from 'react-hook-form'
import { Input, InputProps } from '@surecompanies/core_components'
import { Stack, TextColors, Typography } from '@sureco/design-system'

type RHFInputProps = Omit<InputProps, 'name'> & {
  name: string
  control: Control<any, object>
  rules?: UseControllerProps['rules']
  label?: string
  required?: boolean
  decimalPlaces?: number
  padStart?: number
}

export default function RHFInput({
  name,
  control,
  rules,
  label,
  required,
  step,
  type,
  min,
  max,
  decimalPlaces,
  padStart,
  ...rest
}: RHFInputProps) {
  const resolvedStep = type === 'number' && step === undefined ? 'any' : step
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        return (
          <Stack space={2}>
            {label && (
              <Typography>
                {label}
                {required && <span className="requiredMark">*</span>}
              </Typography>
            )}
            <Input
              name={field.name}
              status={fieldState.error ? 'error' : undefined}
              onBlur={() => {
                let currentValue = field.value
                if (
                  decimalPlaces !== undefined &&
                  currentValue !== '' &&
                  currentValue != null
                ) {
                  const n = Number(currentValue)
                  if (!isNaN(n)) {
                    currentValue = n.toFixed(decimalPlaces)
                    field.onChange(currentValue)
                  }
                }
                if (
                  padStart !== undefined &&
                  currentValue !== '' &&
                  currentValue != null
                ) {
                  field.onChange(String(currentValue).padStart(padStart, '0'))
                }
                field.onBlur()
              }}
              value={field.value}
              onChange={(event) => {
                if (type === 'number') {
                  const raw = event.target.value
                  if (raw !== '' && raw !== '-') {
                    const n = Number(raw)
                    if (min !== undefined && n < Number(min)) {
                      field.onChange(Number(min))
                      return
                    }
                    if (max !== undefined && n > Number(max)) {
                      field.onChange(Number(max))
                      return
                    }
                  }
                }
                field.onChange(event)
              }}
              ref={field.ref}
              type={type}
              step={resolvedStep}
              min={min}
              max={max}
              {...rest}
            />
            {fieldState.error && (
              <Typography color={TextColors.error}>
                {fieldState.error.message}
              </Typography>
            )}
          </Stack>
        )
      }}
    />
  )
}
